import { QueryObserverResult, useQuery } from '@tanstack/react-query'
import { IPendingRollupDataset } from '@global/types'
import { api } from 'api'

interface IArgs {
  datasetId: string
  onSuccess: (data: IPendingRollupDataset) => void
}

/**
 * React Query Hook to fetch pending rollup dataset data.
 */
export function useQueryPendingRollup({
  datasetId,
  onSuccess,
}: IArgs): QueryObserverResult<IPendingRollupDataset, Error> {
  async function fetchPendingRollupDataset(): Promise<IPendingRollupDataset> {
    const { data } = await api.get(`/api/core/v1/pending-rollup/dataset/${datasetId}`)

    return data
  }

  return useQuery({
    queryKey: ['fetchPendingRollupDataset', datasetId],
    queryFn: fetchPendingRollupDataset,
    refetchOnWindowFocus: false,
    onSuccess,
  })
}
